import {
	mainImg,
	plus01img,
	plus02img,
	plus03img,
	plus04img,
	plus05img, sample01img, sample02img, sample03img,
	sr01img,
	sr02img,
	sr03img,
	sr04img
} from "./DataConst";

export interface IMangaInfo {
	width: number,
	height: number
}

const emptyInfo: IMangaInfo = {
	width: -1,
	height: -1
};

export class MangaInfo {

	public mainImage: IMangaInfo = emptyInfo;

	public carousel01info: IMangaInfo = emptyInfo;
	public carousel02info: IMangaInfo = emptyInfo;
	public carousel03info: IMangaInfo = emptyInfo;

	public plus01info: IMangaInfo = emptyInfo;
	public plus02info: IMangaInfo = emptyInfo;
	public plus03info: IMangaInfo = emptyInfo;
	public plus04info: IMangaInfo = emptyInfo;
	public plus05info: IMangaInfo = emptyInfo;

	public sr01info: IMangaInfo = emptyInfo;
	public sr02info: IMangaInfo = emptyInfo;
	public sr03info: IMangaInfo = emptyInfo;
	public sr04info: IMangaInfo = emptyInfo;

	private _komaCount: number = 0;

	private _carouselCount: number = 0;

	private _mainLoaded: boolean = false;
	public get mainLoaded():boolean{
		return this._mainLoaded;
	}

	private _carouselLoaded: boolean = false;

	private _komaLoaded: boolean = false;

	private _waitMainFunc: () => void = () => () => {
		console.log( "main show" );
	};

	public setWaitMainFunc( func: () => void ): void {
		if ( this._mainLoaded ) {
			func();
			return;
		}
		this._waitMainFunc = func;
	}

	private _waitCarouselFunc: () => void = () => () => {
		console.log( "carousel show" );
	};

	public setWaitCarouselFunc( func: () => void ): void {
		if ( this._carouselLoaded ) {
			func();
			return;
		}
		this._waitCarouselFunc = func;
	}

	private _waitKomaFunc: (() => void)[] = [];

	public addWaitKomaFunc( func: () => void ): void {
		if ( this._komaLoaded ) {
			func();
			return;
		}
		this._waitKomaFunc.push( func );
	}

	constructor() {
		// setTimeout( () => {

		this.loadImg( mainImg ).then( ( info ) => {
			this.mainImage = info;
			this._mainLoaded = true;
			this._waitMainFunc();
			this._waitMainFunc = () => console.log( "image loading finished." );

			// setTimeout( () => {

			this.loadImg( sample01img ).then( ( info ) => {
				this.carousel01info = info;
				this.carouselCount();
			} );
			this.loadImg( sample02img ).then( ( info ) => {
				this.carousel02info = info;
				this.carouselCount();
			} );
			this.loadImg( sample03img ).then( ( info ) => {
				this.carousel03info = info;
				this.carouselCount();
			} );
			// }, 2000 );
		} );
		// }, 2000 );
	}

	private loadImg( target: string ): Promise<any> {
		return new Promise<any>( (
			resolve,
			reject
		) => {
			const img = new Image();
			img.onload = () => {
				resolve( this.createMangaInfo( img ) );
			};
			img.src = target;
		} );
	}

	private createMangaInfo( value: HTMLImageElement ): IMangaInfo {
		return {
			width: value.width,
			height: value.height
		}
	}

	private carouselCount(): void {
		this._carouselCount++;
		if ( this._carouselCount !== 3 ) {
			return;
		}
		this._carouselLoaded = true;

		this._waitCarouselFunc();
		this._waitCarouselFunc = () => console.log( "carousel images loading finished." );

		// setTimeout( () => {

		// ロード開始
		this.loadImg( plus01img ).then( ( info ) => {
			this.plus01info = info;
			this.komaCount();
		} );
		this.loadImg( plus02img ).then( ( info ) => {
			this.plus02info = info;
			this.komaCount();
		} );
		this.loadImg( plus03img ).then( ( info ) => {
			this.plus03info = info;
			this.komaCount();
		} );
		this.loadImg( plus04img ).then( ( info ) => {
			this.plus04info = info;
			this.komaCount();
		} );
		this.loadImg( plus05img ).then( ( info ) => {
			this.plus05info = info;
			this.komaCount();
		} );

		// sr
		this.loadImg( sr01img ).then( ( info ) => {
			this.sr01info = info;
			this.komaCount();
		} );
		this.loadImg( sr02img ).then( ( info ) => {
			this.sr02info = info;
			this.komaCount();
		} );
		this.loadImg( sr03img ).then( ( info ) => {
			this.sr03info = info;
			this.komaCount();
		} );
		this.loadImg( sr04img ).then( ( info ) => {
			this.sr04info = info;
			this.komaCount();
		} );

		// }, 2000 );
	}

	private komaCount(): void {
		this._komaCount++;
		// console.log( this._komaCount );
		if ( this._komaCount !== 9 ) {
			return;
		}
		this._komaLoaded = true;

		const len = this._waitKomaFunc.length;
		for ( let i = 0; i < len; i++ ) {
			this._waitKomaFunc[ i ]();
		}
		this._waitKomaFunc = [];
	}
}

const mangaInfo: MangaInfo = new MangaInfo();

export default mangaInfo;